import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';

export interface SignalRConfig {
  lockName: string;
  cursorStorageKey: string;
  // url: (lastId: string | null) => string;
  negoatiateUrl: (lastId: string | null) => Promise<{ url: string; accessToken: string }>;
  hubMethod?: string;
}

export const SIGNALR_CONFIG = new InjectionToken<SignalRConfig>('SIGNALR_CONFIG');

export function provideSignalR(config: SignalRConfig): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: SIGNALR_CONFIG, useValue: config }]);
}
